/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Navbar_LogoutInputs */

const de_auth_navbar_logout = /** @type {(inputs: Auth_Navbar_LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abmelden`)
};

/** @type {(inputs: Auth_Navbar_LogoutInputs) => LocalizedString} */
const en_auth_navbar_logout = de_auth_navbar_logout;

/**

* @param {Auth_Navbar_LogoutInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_navbar_logout = /** @type {((inputs?: Auth_Navbar_LogoutInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Navbar_LogoutInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_auth_navbar_logout(inputs)
	return en_auth_navbar_logout(inputs)
});